import { eventService } from '../services'

const state = {
  events: [],
  event: null,
  itemsPerPage: 25,
  childrenItemsPerPage: 25,
  paginationChildren: 0,
  parents: [],
  children: [],
  childrenAvailable: [],
  initialStatus: null,
  datatableParams: null,
  files: [],
  history: [],
  file: null
}

const getters = {
  findAll (state) {
    return state.events
  },
  find (state) {
    return id => state.events.find(event => event.id === id)
  },
  paginationChildren (state) {
    return state.paginationChildren
  },
  getItemsPerPage (state) {
    return state.itemsPerPage
  },
  getChildrenItemsPerPage (state) {
    return state.childrenItemsPerPage
  },
  currentEvent (state) {
    return state.event
  },
  getAllParents (state) {
    return state.parents
  },
  getChildren (state) {
    return state.children
  },
  getInitialStatus (state) {
    return state.initialStatus
  },
  getStatusPosition (state) {
    return status => state.statuses[status].position
  },
  getAllChildrenAvailable (state) {
    return state.childrenAvailable
  },
  findAllFiles (state) {
    return state.files
  },
  findFile (state) {
    return state.file
  },
  findHistory (state) {
    return state.history
  }
}

const mutations = {
  create (state, item) {
    const foundAt = state.events.findIndex(evt => evt.id === item.id)
    if (foundAt === -1) {
      state.events.push(item)
    }
  },
  update (state, { id, item }) {
    const foundAt = state.events.findIndex(event => event.id === id)
    state.events.splice(foundAt, 1, item)
  },
  delete (state, id) {
    const index = state.events.findIndex(event => event.id === id)
    const indexChildren = state.children.findIndex(event => event.id === id)

    if (index !== -1) {
      state.events.splice(index, 1)
    }

    if (indexChildren !== -1) {
      state.children.splice(indexChildren, 1)
    }

    if (state.paginationChildren) {
      state.paginationChildren.totalItems = state.children.length
    }
  },
  getAll (state, events) {
    state.events = events.map(event => {
      return {
        ...event,
        natureLabel: event.nature.label
      }
    })
  },
  getAllParents (state, parents) {
    parents.unshift({
      id: null,
      label: ''
    })
    state.parents = parents
  },
  getChildren (state, children) {
    state.children = children
  },
  paginationChildren (state, paginationChildren) {
    state.paginationChildren = paginationChildren
  },
  find (state, event) {
    if (event.parent !== null) {
      event.parent = {
        id: event.parent.id,
        label: event.parent.label,
        endingDate: event.parent.endingDate,
        startingDate: event.parent.startingDate
      }
    } else {
      event.parent = {
        id: null,
        label: ''
      }
    }

    if (event.origin === null) {
      if (event.otherOrigin === null) {
        event.origin = { id: null, label: '' }
      } else {
        event.origin = { id: 'other', label: 'Autre' }
      }
    }

    if (event.recipient === null) {
      if (event.otherRecipient === null) {
        event.recipient = { id: null, label: '' }
      } else {
        event.recipient = { id: 'other', label: 'Autre' }
      }
    }

    state.initialStatus = event.status
    state.event = event
  },
  resetCurrentEvent (state) {
    state.event = null
  },
  setItemsPerPage (state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  },
  setChildrenItemsPerPage (state, childrenItemsPerPage) {
    state.childrenItemsPerPage = childrenItemsPerPage
  },
  getAllChildrenAvailable (state, childrenAvailable) {
    state.childrenAvailable = childrenAvailable
  },
  findAllFiles (state, files) {
    state.files = files
  },
  removeFile (state, fileId) {
    const foundAt = state.files.findIndex(file => file.id === fileId)

    if (foundAt > -1) {
      state.files.splice(foundAt, 1)
    }
  },
  addFile (state, file) {
    state.files.push(file)
  },
  findFile (state, fileId) {
    state.file = state.event.attachments.find(file => file.id === fileId)
  },
  findHistory (state, history) {
    state.history = history
  }
}

const actions = {
  findAll (context) {
    return eventService.findAll()
      .then(response => {
        context.commit('getAll', response.data)
        return response
      })
  },
  find (context, id) {
    return eventService.find(id)
      .then(response => {
        context.commit('find', response.data)
        return response
      })
  },
  findAllParents (context, id) {
    return eventService.findAllParents(id)
      .then(response => {
        context.commit('getAllParents', response.data)
      })
  },
  findChildren (context, params) {
    return eventService.findChildren(params)
      .then(response => {
        context.commit('getChildren', response.data.items)
        context.commit('paginationChildren', response.data.pagination)
        return response
      })
  },
  create (context, event) {
    context.dispatch('loader/startLoading', 'event/create', { root: true })
    return eventService.create(event)
      .then(response => {
        context.commit('create', response.data)
        context.dispatch('alert/success', `Création réussie de l'événement ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la création de l'événement ${event.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'event/create', { root: true })
      })
  },
  update (context, { id, event }) {
    context.dispatch('loader/startLoading', 'event/update', { root: true })
    return eventService.update(id, event)
      .then(response => {
        context.commit('update', { id, item: response.data })
        context.dispatch('alert/success', `Mise à jour réussie de l'événement ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(error => {
        if (error.response.data.errors.children.parent.errors && error.response.data.errors.children.parent.errors.length > 0) {
          context.dispatch('alert/error', 'Echec de la mise à jour : Evénement parent actuellement Terminé.', { root: true })
        } else {
          context.dispatch('alert/error', `Echec de la mise à jour de l'événement ${event.label}.`, { root: true })
        }
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'event/update', { root: true })
      })
  },
  updateEventPart (context, { id, label, eventPart }) {
    context.dispatch('loader/startLoading', 'event/update', { root: true })
    return eventService.updatePart(id, eventPart)
      .then(response => {
        context.dispatch('alert/success', `Mise à jour réussie de l'événement ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(error => {
        if (error.response.data.errors.children.parent.errors && error.response.data.errors.children.parent.errors.length > 0) {
          context.dispatch('alert/error', 'Echec de la mise à jour : Evénement parent actuellement Terminé.', { root: true })
        } else {
          context.dispatch('alert/error', `Echec de la mise à jour de l'événement ${label}.`, { root: true })
        }
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'event/update', { root: true })
      })
  },
  delete (context, id) {
    return eventService.deleteEvent(id)
      .then(response => {
        context.commit('delete', id)
        return response
      })
  },
  resetCurrentEvent (context) {
    context.commit('resetCurrentEvent')
  },
  setItemsPerPage (context, itemsPerPage) {
    context.commit('setItemsPerPage', itemsPerPage)
  },
  setChildrenItemsPerPage (context, childrenitemsPerPage) {
    context.commit('setChildrenItemsPerPage', childrenitemsPerPage)
  },
  findAvailableChildren (context, id) {
    return eventService.findAvailableChildren(id)
      .then(response => {
        context.commit('getAllChildrenAvailable', response.data)
      })
  },
  findAllFiles (context, files) {
    context.commit('findAllFiles', files)
  },
  removeFile (context, fileId) {
    return eventService.removeFile(fileId)
      .then(() => {
        context.commit('removeFile', fileId)
        context.dispatch('alert/success', 'La pièce jointe a bien été supprimée', { root: true })
      })
      .catch(() => {
        context.dispatch('alert/error', 'La suppression de la pièce jointe a échoué.', { root: true })
      })
  },
  findFile (context, fileId) {
    context.commit('findFile', fileId)
  },
  findHistory (context, id) {
    return eventService.findHistory(id)
      .then(response => {
        context.commit('findHistory', response.data)
        return response
      })
  },
  exportEvent (context, { eventId, mapUrl, format, type }) {
    context.dispatch('loader/startLoading', 'event/export', { root: true })
    return eventService.exportEvent(eventId, mapUrl, format, type)
      .catch(() => {
        context.dispatch('alert/error', `Echec de l'export de l'événement ${eventId}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'event/export', { root: true })
      })
  },
  duplicateEvent (context, { eventId, duplicatedDate }) {
    context.dispatch('loader/startLoading', 'event/duplicate', { root: true })
    return eventService.duplicateEvent(eventId, duplicatedDate)
      .then(() => {
        context.dispatch('alert/success', 'La duplication de l\'événement a réussi.', { root: true })
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la duplication de l'événement ${eventId}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'event/duplicate', { root: true })
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
